// @ts-nocheck
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Units from './pages/Units';
import Materials from './pages/Materials';
import Leads from './pages/Leads';
import Bookings from './pages/Bookings';
import BookingDetail from './pages/BookingDetail';
import Payments from './pages/Payments';
import Accounts from './pages/Accounts';
import AccountingReports from './pages/AccountingReports';
import Reports from './pages/Reports';
import Permissions from './pages/Permissions';
import Portal from './pages/Portal';
import Profile from './pages/Profile';
import Users from './pages/Users';
import Chat from './pages/Chat';
import SystemAdmin from './pages/SystemAdmin';
import BankAssets from './pages/BankAssets';
import Advanced from './pages/Advanced';

function App() {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100">
                <div className="spinner-border text-success" />
            </div>
        );
    }

    return (
        <Routes>
            <Route
                path="/login"
                element={user ? <Navigate to={user.role === 'customer' ? '/portal' : '/dashboard'} /> : <Login />}
            />

            <Route
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute roles={['admin', 'sales', 'finance']} module="dashboard">
                            <Dashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/projects"
                    element={
                        <ProtectedRoute roles={['admin', 'sales', 'finance']} module="projects">
                            <Projects />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/projects/:id"
                    element={
                        <ProtectedRoute roles={['admin', 'sales', 'finance']} module="projects">
                            <ProjectDetail />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/units"
                    element={
                        <ProtectedRoute roles={['admin', 'sales', 'finance']} module="units">
                            <Units />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/materials"
                    element={
                        <ProtectedRoute roles={['admin', 'sales', 'finance']} module="materials">
                            <Materials />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/leads"
                    element={
                        <ProtectedRoute roles={['admin', 'sales']} module="leads">
                            <Leads />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/bookings"
                    element={
                        <ProtectedRoute roles={['admin', 'sales', 'finance']} module="bookings">
                            <Bookings />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/bookings/:id"
                    element={
                        <ProtectedRoute roles={['admin', 'sales', 'finance', 'customer']} module="bookings">
                            <BookingDetail />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/payments"
                    element={
                        <ProtectedRoute roles={['admin', 'sales', 'finance']} module="payments">
                            <Payments />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/accounts"
                    element={
                        <ProtectedRoute roles={['admin', 'finance']} module="accounts">
                            <Accounts />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/accounting-reports"
                    element={
                        <ProtectedRoute roles={['admin', 'finance']} module="accounting_reports">
                            <AccountingReports />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/reports"
                    element={
                        <ProtectedRoute roles={['admin', 'sales', 'finance']} module="reports">
                            <Reports />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/permissions"
                    element={
                        <ProtectedRoute roles={['admin']} module="permissions">
                            <Permissions />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                        <ProtectedRoute roles={['admin']} module="users">
                            <Users />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/chat"
                    element={
                        <ProtectedRoute module="chat">
                            <Chat />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/system"
                    element={
                        <ProtectedRoute roles={['super_admin', 'admin']}>
                            <SystemAdmin />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/advanced"
                    element={
                        <ProtectedRoute roles={['super_admin', 'admin', 'finance']} module="accounts">
                            <Advanced />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/bank-assets"
                    element={
                        <ProtectedRoute roles={['super_admin', 'admin', 'finance']} module="bank">
                            <BankAssets />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/portal"
                    element={
                        <ProtectedRoute roles={['customer']} module="portal">
                            <Portal />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/portal/bookings"
                    element={
                        <ProtectedRoute roles={['customer']} module="portal">
                            <Bookings />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/portal/bookings/:id"
                    element={
                        <ProtectedRoute roles={['customer']} module="portal">
                            <BookingDetail />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/portal/payments"
                    element={
                        <ProtectedRoute roles={['customer']} module="portal">
                            <Payments />
                        </ProtectedRoute>
                    }
                />
                <Route path="/profile" element={<Profile />} />
            </Route>

            <Route
                path="*"
                element={
                    <Navigate to={user ? (user.role === 'customer' ? '/portal' : '/dashboard') : '/login'} />
                }
            />
        </Routes>
    );
}

export default App;
